module.exports = __webpack_public_path__ + "img/otp_code.8e94f4a4.svg";